if (!window.__tsdTestimonialsReady) {
  window.__tsdTestimonialsReady = true;

  const openCard = (card) => {
    const root = card.closest('.tsd-testimonials');
    const dialog = root && root.querySelector('.tsd-testimonials__dialog');
    if (!dialog) return;
    dialog.querySelector('.tsd-testimonials__dialog-quote').innerHTML =
      card.querySelector('.tsd-testimonial__full').innerHTML;
    dialog.querySelector('.tsd-testimonials__dialog-name').textContent =
      card.querySelector('.tsd-testimonial__name')?.textContent || '';
    dialog.querySelector('.tsd-testimonials__dialog-occasion').textContent =
      card.querySelector('.tsd-testimonial__occasion')?.textContent || '';
    dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('.tsd-testimonials__close')) {
      target.closest('dialog').close();
      return;
    }

    const card = target.closest('.tsd-testimonial');
    if (card) {
      openCard(card);
      return;
    }

    if (target.matches('.tsd-testimonials__dialog')) {
      if (event.clientX === 0 && event.clientY === 0) return;
      const rect = target.getBoundingClientRect();
      const outside =
        event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom;
      if (outside) target.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const card = event.target instanceof Element && event.target.closest('.tsd-testimonial');
    if (card && event.target === card) {
      event.preventDefault();
      openCard(card);
    }
  });
}
